export const NO_INTERNET = "Check your internert connection.";
export const INTERNAL_SERVER_ERROR = "Something went wrong";
export const UNAUTHORIZED = "Unauthorized User";

export enum USER_ROLE {
  ADMIN = "admin",
  SYSTEM_ADMIN = "system-admin",
  SUPER_SYSTEM_ADMIN = "system-super-admin",
  ORG_ADMIN = "org-admin",
  CONTRIBUTOR = "contributor",
  EXPLORER = "explorer",
  DATA_ONBOARDING_APPROVER = "data-onboarding-approver",
  DATA_ONBOARDING_MANAGER = "data-onboarding-manager",
  ORGANIZATION_ONBOARDING_APPROVER = "organization-onboarding-approver",
  ORGANIZATION_ONBOARDING_MANAGER = "organization-onboarding-manager",
  COMPUTE_APPROVER = "compute-approver",
  COMPETITION_ANALYTICS = "competition_analytics",
  ONBOARDING_APPROVER = "onboarding-approver",
}

export enum TransactionType {
  SFTP_TRANSFER = "SFTP_TRANSFER",
  APPROVED_TRANSFER = "APPROVED_TRANSFER",
}

export const excludeUrls = [
  "data:",
  "/rser",
  "/bilogs",
  "/digiLockerNewApi/ws1/uploadfile",
  "/frontapi/encdec/umang/xdigicommonencryptrequest/initauth",
  "/sync-departments",
  "/sync-services",
  "/schemes-list",
  "/data-sync",
  "/digilocker-elastic/sync",
];

export const regexList = {
  url: /^(http(s)?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/,
  number: /^[0-9]\d*$/,
  numberWithComma: /^(?:\d{7,},)*\d{7,}$/,
  alphabetString: /^(?!\s)[a-zA-Z ]+$/,
  alphaNumericString: /^(?!\s)([a-zA-Z0-9]{1})([a-zA-Z0-9 ]{0,})+$/,
  email: /^(?!.*(?:''|\.\.))[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
  // url:/^(https?|ftp):\/\/[^\s\/$?#].[^\s]*$/
};

export const statusList = [
  { key: "A", value: "Active" },
  { key: "In", value: "Inactive" },
];

export const CONTENT_FORMS_NAME = {
  ABOUT_US: "about_us",
  FAQ: "faq",
  TERMS_AND_CONDITIONS: "terms_and_conditions",
  ORG_TERMS_AND_CONDITIONS: "org_terms_and_conditions",
  ARTICLES: "article",
  INDIVIDUAL_TERMS_AND_CONDITIONS: "individual_terms_and_conditions",
  PRIVACE_POLICY: "privacy_policy",
  USER_MANUALS: "user_manuals",
  METADATA_STANDARDS: "metadata_standards",
  NOTEBOOK_CONTENT: "notebook_content",
};

export const STATIC_KEYS = {
  IDP_AUTH_TOKEN: "idp_auth_token",
  PERMISSIONS: "permissions",
  LOGGED_IN_USER_INFO: "loggedInUserInfo",
  DATASET_FILTER: "dataset-filters",
  MODEL_FILTER: "model-filters",
  USECASE_FILTER: "usecase-filters",
  DATASET_FILTER_APPROVAL: "dataset-filters-ap",
  MODEL_FILTER_APPROVAL: "model-filters-ap",
  USECASE_FILTER_APPROVAL: "usecase-filters-ap",
  TOOLKIT_FILTER_APPROVAL: "toolkit-filters-ap",
  ARTICLE_FILTER_APPROVAL: "article-filters-ap",
  ORGANIZATION_APPROVAL: "organization-filter-approval",
  ORGANIZATION_LIST: "organization-filter-list",
  USER_LIST: "user-filter-list",
  DISPUTED_ARTEFACT: "disputed-artefacts-filter",
  GENERAL_GRIEVANCES: "general-grievances-filter",
};

export const DASHBOARD_PAGES = {
  HALLS: "HALLS",
  STALLS: "STALLS",
  HOME: "HOME",
};

export const PERMISSIONS = {
  // Artefact Approvals
  ARTEFACT_APPROVALS: "artefact-approvals",
  ARTEFACT_LIST: "artefact-list",
  ARTEFACT_APPROVALS_VERSION: "artefact-approvals-version",

  // dashboard
  DASHBOARD: "dashboard",

  // reset password
  RESET_PASSWORD: "reset-password",

  // content
  CONTENT: "content",

  // Banner Image
  BANNER_IMAGE: "banner_image",
  EDIT_BANNER_IMAGE: "edit_banner_image",
  ADD_BANNER_IMAGE: "add_banner_image",

  // System Params
  SYSTEM_PARAMS: "system_params",
  EDIT_SYSTEM_PARAMS: "edit_system_params",
  ADD_SYSTEM_PARAMS: "add_system_params",
  DELETE_SYSTEM_PARAMS: "delete_system_params",

  // Banner Image V2
  BANNER_IMAGE_V2: "banner_image_v2",
  EDIT_BANNER_IMAGE_V2: "edit_banner_image_v2",
  ADD_BANNER_IMAGE_V2: "add_banner_image_v2",

  // About ITPO
  ABOUT_ITPO: "about_itpo",
  EDIT_ABOUT_ITPO: "edit_about_itpo",
  ADD_ABOUT_ITPO: "add_about_itpo",
  DELETE_ABOUT_ITPO: "delete_about_itpo",

  // About Bharat Mandapam
  ABOUT_BHARAT_MANDAPAM: "about_bharat_mandapam",
  EDIT_ABOUT_BHARAT_MANDAPAM: "edit_about_bharat_mandapam",
  ADD_ABOUT_BHARAT_MANDAPAM: "add_about_bharat_mandapam",
  DELETE_ABOUT_BHARAT_MANDAPM: "delete_about_bharat_mandapm",

  // ITPO calender
  IPTO_CALENDER: "itpo_calender",
  ADD_ITPO_CALENDER: "add_itpo_calender",
  EDIT_IPTO_CALENDER: "edit_itpo_calender",
  DUPLICATE_CONTENT: "duplicate_content",

  // ITPO Bulletin
  ADD_ITPO_BULLETIN: "add_itpo_bulletin",
  EDIT_ITPO_BULLETIN: "edit_itpo_bulletin",
  DELETE_ITPO_BULLETIN: "DELETE_itpo_bulletin",

  // Explore India
  EXPLORE_INDIA: "explore_india",
  EDIT_EXPLORE_INDIA: "edit_explore_india",
  ADD_EXPLORE_INDIA: "add_explore_india",
  DELETE_EXPLORE_INDIA: "delete_explore_india",

  // terms and conditions
  TERMS_AND_CONDITITIONS: "terms_and_conditions",
  EDIT_TERMS_AND_CONDITITIONS: "edit_terms_and_condition",
  ADD_TERMS_AND_CONDITITIONS: "add_terms_and_condition",
  DELETE_TERMS_AND_CONDITITIONS: "delete_terms_and_condition",

  // Privacy policy
  PRIVACY_POLICY: "privacy_policy",
  EDIT_PRIVACY_POLICY: "edit_privacy_policy",
  ADD_PRIVACY_POLICY: "add_privacy_policy",
  DELETE_PRIVACY_POLICY: "delete_privacy_policy",

  // Digital India
  DIGITAL_INDIA_INITIATIVE: "digital_india_initiative",
  EDIT_DIGITAL_INDIA_INITIATIVE: "edit_digital_india_initiative",
  ADD_DIGITAL_INDIA_INITIATIVE: "add_digital_india_initiative",
  DELETE_DIGITAL_INDIA_INITIATIVE: "delete_digital_india_initiative",

  // EVent Bulletin
  EVENT_BULLETIN: "event_bulletin",
  ADD_EVENT_BULLETIN: "add_event_bulletin",
  EDIT_EVENT_BULLETIN: "edit_event_bulletin",
  DELETE_EVENT_BULLETIN: "delete_event_bulletin",

  // Live Events
  LIVE_EVENTS: "live_events",
  EDIT_LIVE_EVENTS: "edit_live_events",
  ADD_LIVE_EVENTS: "add_live_events",
  DELETE_LIVE_EVENTS: "delete_live_events",

  DELEGATE_EXPERIENCE: "delegate_experience",
  EDIT_DELEGATE_EXPERIENCE: "edit_delegate_experience",
  ADD_DELEGATE_EXPERIENCE: "add_delegate_experience",
  DELETE_DELEGATE_EXPERIENCE: "delete_delegate_experience",

  FAQ: "faq",
  EDIT_FAQ: "edit_faq",
  ADD_FAQ: "add_faq",
  DELETE_FAQ: "delete_faq",
  SECTOR_LIST: "sector-list",
  ADD_SECTORS: "add-sector",

  EVENT_LAYOUTS: "event_layouts",
  EDIT_EVENT_LAYOUTS: "edit_event_layouts",
  ADD_EVENT_LAYOUTS: "add_event_layouts",
  DELETE_EVENT_LAYOUTS: "delete_event_layouts",

  // events
  EVENTS: "events",
  ADD_EVENT: "add_event",
  EDIT_EVENT: "edit_event",

  // past events
  PAST_EVENTS: "past_events",

  // Halls
  HALLS: "halls",
  ADD_EVENT_HALLS: "add_event_halls",
  EDIT_EVENT_HALLS: "edit_event_halls",
  DELETE_EVENT_HALL: "delete_event_halls",
  BOOK_HALLS: "book_halls",

  // stalls
  STALL_LIST: "stall_list",
  IMPORT_STALLS: "import_stalls",
  EXPORT_STALLS: "export_stalls",

  // users
  USERS: "users",
  CREATE_USER: "create_user",
  ADD_USER_ROLE: "add_user_role",
  EDIT_USER_ROLE: "edit_user_role",
  DELETE_USER_ROLE: "delete_user_role",

  // roles & permissions
  ROLES_AND_PERMISSIONS: "roles_and_permissions",
  ROLES_LIST: "roles_list",
  ADD_ROLE: "add_role",
  EDIT_ROLE: "edit_role",
  PERMISSION_LIST: "permission_list",
  ADD_PERMISSION: "add_permission",
  VIEW_PERMISSION: "view_permission",

  // dataset
  DATASETS: "datasets",

  // toolkits
  TOOLKITS: "toolkits",

  //Use Case
  USE_CASE: "Use Case",
  // Resources
  RESOURCES: "resources",

  // Organisaion
  ORGANISATION: "organisation",

  // master data
  MASTER_DATA: "master-data",

  // Org Approval
  ORG_APPROVAL: "org_approval",

  //model
  MODELS: "models",

  // home
  HOME: "home",

  // all
  ALL: "all",
  REPORT_ARTIFCATS: "report_artifacts",

  // Role Management
  ROLE_MANAGEMENT: "roleManagement",
  MANAGE_TEAM_ROLES: "manage_team_roles",
};

export enum ROLE_RESOURCE_PERMISSIONS {
  // Content Management
  ABOUT_US = "r-aboutUs",
  FAQ = "r-faq",
  TERMS_AND_CONDITIONS = "r-termsAndConditions",
  PRIVACY_POLICY = "r-privacyPolicy",
  USER_MANUALS = "r-userManuals",
  METADATA_CONTENT = "r-metadataContent",
  ARTICLES = "r-articles",
  ARTICLES_APPROVAL = "r-articlesApproval",
  MAINTENANCE = "r-maintenance",
  MASTER_DATA = "r-masterData",
  BANNERS = "r-banners",
  NOTEBOOK_CONTENT = "r-notebookContent",
  ARTEFACT_NOTES_LIST = "r-artefactNotesList",

  // Role Management
  ROLES = "r-roles",
  RESOURCES = "r-resources",
  ACTIONS = "r-actions",
  PERMISSION = "r-permission",
  ROLE_PERMISSIONS = "r-rolePermissions",

  // Other Permissions
  DASHBOARD = "r-dashboard",
  ORG_APPROVAL = "r-organizationApproval",
  COMPETITIONS = "r-competitions",
  ARTEFACT_APPROVALS = "r-artefactsApprovals",
  ORGANISATION = "r-organizations",
  USERS = "r-users",
  ARTEFACTS = "r-artefacts",
  SECTOR_THEME = "r-sectorThemes",
  TOOLKIT_MANAGEMENT = "r-toolkitManagement",
  TOOLKIT_MANAGEMENT_STEP = "r-toolkitManagementStep",
  TUTORIALS = "r-tutorials",
  MODEL = "r-model",
  DATASET = "r-dataset",
  USECASE = "r-usecase",
  MANAGE_GRIEVANCES = "r-manageGrievances",
  MANAGE_TEAM_ROLES = "r-manageTeamRoles",
  ARTEFACT_APPROVALS_VERSION = "r-artefactApprovalsVersion",
  COMPUTE_NOTEBOOK = "r-computeNotebook",
}

export enum RESOURCE_ACTION {
  LIST = "list",
  DETAIL = "read",
  VIEW_NOTE = "viewNote",
  ADD_NOTE = "addNote",
  MANAGE_ACCESS = "manageAccess",
  VIEW_REJECTION_REASON = "viewRejectionReason",
  VIEW_FLAG_REASON = "viewFLagReason",
  DOWNLOAD_LOGS = "downloadLogs",
  FLAG_DATASET = "flagDataset",
  UPDATE = "update",
  ADD = "create",
  DELETE = "delete",
  APPROVE = "approve",
  REJECT = "reject",
  DOWNLOAD = "download",
  ADD_ROLES = "addRoles",
  ARTEFACT_DISCOVERABILITY = "artefactsDiscoverablity",
  USER_BLOCK = "blockUser",
  USER_UNBLOCK = "unblockUser",
  ASSIGN_DOA = "assign-doa",
  ASSIGNMENT_DETAILS = "/assignment-details",
  VIEW_AUDIT_TRAILS = "viewAuditTrails",
}

export enum Form_Review_Status {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
}

export enum ReviewStatus {
  Approved = "Approved",
  Rejected = "Rejected",
  Pending = "Pending",
  Appealed = "Appealed",
  Draft = "Draft",
  Under_Review = "Under_Review",
  Escalated = "Escalated",
  Active = "Active",
  Blocked = "Blocked",
  Flagged = "Flagged",
  Inactive = "Inactive",
  Open = "Open",
  LevelApproved = "Level 1 Approved",
  Resolved = "Resolved",
  Processed = "Processed",
  Failed = "Failed",
  Scheduled = "Scheduled",
  Ready = "Ready",
  ReadyForFileCopy = "Ready for File Copy",
  Expired = "Expired",
  Completed = "Completed",
  Create = "CREATE",
  Update = "UPDATE",
  Revoked = "Revoked",
  Delete = "DELETE",
  Success = "success",
  FailedLower = "failed",
  Submitted = "Submitted",
  Re_Requested = "Re-Requested",
}

export enum UsecaseTypes {
  Usecase = "Usecase",
  Tryout = "Tryout",
}

export const reviewStatusOptions = [
  { id: ReviewStatus.Approved, name: ReviewStatus.Approved },
  { id: ReviewStatus.Rejected, name: ReviewStatus.Rejected },
  { id: ReviewStatus.Pending, name: ReviewStatus.Pending },
  { id: ReviewStatus.Appealed, name: ReviewStatus.Appealed },
  { id: ReviewStatus.Draft, name: ReviewStatus.Draft },
  { id: ReviewStatus.Under_Review, name: ReviewStatus.Under_Review },
];

export const DonutDummySeries = [1141, 1117, 1115];

export const DonutDummyLabels = ["SciFi", "Drama", "Horror"];

export const ARTEFACTS: any = {
  datasets: "Datasets",
  ai_models: "AI Models",
  use_cases: "Use Cases",
  organizations: "Organizations",
} as const;

export const StatusStyles: any = {
  Approved: {
    color: "#008805",
    background: "#0088050F",
  },
  Rejected: {
    color: "#BA1A1A",
    background: "#BA1A1A0F",
  },
  Pending: {
    color: "#B77E04",
    background: "#F9ECB9",
  },
  Appealed: {
    color: "#9A6700",
    background: "#9A67000F",
  },
  Draft: {
    color: "#5B5B5B",
    background: "#5B5B5B0F",
  },
  Under_Review: {
    color: "#004AAD",
    background: "#004AAD0F",
  },
};
export const orgStatusOptions = [
  { label: ReviewStatus.Pending, value: ReviewStatus.Pending },
  { label: ReviewStatus.Rejected, value: ReviewStatus.Rejected },
  { label: "Under Review", value: ReviewStatus.LevelApproved },
  { label: ReviewStatus.Escalated, value: ReviewStatus.Escalated },
  { label: ReviewStatus.Approved, value: ReviewStatus.Approved },
  // { label: "Re Requested", value: "Re-Requested" },
  // { label: "Deactivated", value: "Deactivated" },
];

export const getStatusStyles = (status: string) => {
  switch (status) {
    case ReviewStatus.Active:
    case ReviewStatus.Approved:
    case ReviewStatus.Processed:
    case ReviewStatus.Ready:
    case ReviewStatus.Success:
    case Form_Review_Status.SUBMITTED:
    case ReviewStatus.ReadyForFileCopy:
      return {
        color: "#008805",
        background: "#0088050F",
      };

    case ReviewStatus.Blocked:
    case ReviewStatus.Flagged:
    case ReviewStatus.Rejected:
    case ReviewStatus.Inactive:
    case ReviewStatus.Failed:
    case ReviewStatus.Delete:
    case ReviewStatus.FailedLower:
      return {
        color: "#BA1A1A",
        background: "#BA1A1A0F",
      };

    case ReviewStatus.Pending:
      return {
        color: "#B77E04",
        background: "#F9ECB9",
      };
    case ReviewStatus.Appealed:
      return {
        color: "#9A6700",
        background: "#9A67000F",
      };
    case ReviewStatus.Draft:
    case Form_Review_Status.DRAFT:
      return {
        color: "#5B5B5B",
        background: "#5B5B5B0F",
      };
    case ReviewStatus.Under_Review:
      return {
        color: "#706198",
        background: "#efe9fe",
      };
    case ReviewStatus.Escalated:
      return {
        color: "#ea5b0c",
        background: "#F9D6B9",
      };
    case ReviewStatus.Submitted:
    case ReviewStatus.Expired:
    case ReviewStatus.Completed:
      return {
        color: "#333",
        background: "#efe9fe",
      };
    case ReviewStatus.Scheduled:
      return {
        color: "#18717c",
        background: "#18717c1a",
      };
    case ReviewStatus.Create:
      return {
        color: "#155724",
        background: "#d4edda",
      };
    case ReviewStatus.Update:
      return {
        color: "#856404",
        background: "#fff3cd",
      };
    default:
      return {
        color: "#000000",
        background: "#0000000F",
      };
  }
};

export const OrganizationType = [
  "Public",
  "Private",
  "Research Organisation",
  "University",
  "Startup/MSME",
  // "Default",
  "NGO / Not for profit organization",
];

export const UsageInsightKeys = {
  logins: "logins",
  registrations: "registrations",
  contributorUpgrades: "contributor_conversion",
  artifactUploads: "artefact_uploads",
  accountDeletions: "account_deletions",
  artifactDownloads: "artefact_downloads",
  tootlkitTryout: "toolkit_tryout",
  notebookOpened: "notebook_opened",
  userVisits: "userVisits",
};

export const VersionStats = {
  approved: "approved",
  failed: "failed",
  pending: "pending",
  processing: "processing",
  draft: "draft",
  processed: "processed",
  under_review: "Under Review",
  new: "new",
};

export const UsageInsightUserRole = {
  org_admin: "Organisation Admin",
  explorer: "Explorer",
  contributor: "Contributors",
};

export const UsageInsightActivityType = {
  LOGINS: "logins",
  REGISTRATIONS: "registrations",
  DELETIONS: "deletions",
  ARTIFACT_UPLOADS: "artifact-uploads",
  ARTIFACT_DOWNLOADS: "artifact-downloads",
  CONTRIBUTOR_UPGRADES: "contributor-upgrades",
  TOOLKIT_TRYOUTS: "toolkit-tryouts",
  NOTEBOOKS_OPENED: "notebooks-opened",
  USER_VISITS: "user-visits",
};
